// Slot'un gösterilecek/etkin fiyatını hesaplar (kuruş cinsinden).
//
// İki fiyatlandırma modu vardır (priceOverride alanı):
//   priceOverride = 1  -> "Özel Fiyat": kullanıcının elle girdiği slotPrice kullanılır.
//   priceOverride = 0  -> "Stok Listesi Fiyatı": stoğun GÜNCEL liste fiyatı dinamik olarak
//                          kullanılır. Bu modda slotPrice DB'de 0 (sentinel) tutulur, gerçek
//                          fiyat stok kartından okunur. Stok fiyatı değişirse slot da takip eder.
//
// stockPriceMap: { [stockId]: stockPrice } — stok kartlarından türetilen güncel fiyat haritası.
export function getEffectiveSlotPrice(row, stockPriceMap) {
  if (Number(row?.priceOverride) === 1) {
    return Number(row?.slotPrice) || 0;
  }
  const stockPrice = stockPriceMap?.[row?.stockId];
  return stockPrice != null ? Number(stockPrice) : 0;
}
